import React from 'react';
import EcoClass102023 from 'views/EcoClass102023';

const AccountGeneralPage = () => {
  return <EcoClass102023/>;
};

export default AccountGeneralPage;
